import { __ } from "@wordpress/i18n";

export const COMPARE_FIELDS_OPTIONS = {
  name: __("Name", "brandy-blocks"),
  image: __("Image", "brandy-blocks"),
  description: __("Description", "brandy-blocks"),
  price: __("Price", "brandy-blocks"),
  rating: __("Rating", "brandy-blocks"),
  add_to_cart: __("Add to Cart", "brandy-blocks"),
};
